export * from './atoms';

import { DocumentAtoms } from './atoms';


export const DocumentComponents = [
    ...DocumentAtoms
];